export const colorSuccess = '#00c616';
export const  colorError = 'red';
export const  colorWarning = '#FF8000';
export const  colorInfo = '#0288d1';



// WEBPACK FOOTER //
// ./src/shared/style/color.ts